export default "__VITE_ASSET__BkeD9HWT__"